var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{class:_vm.theClass,staticStyle:{"statistic.isrelativestandarderrortoohigh? 'color":"red' : ''"},attrs:{"aria-label":_vm.theTitle}},[(
      _vm.statistic.statisticDefinition.se !== null &&
      _vm.statistic.value !== undefined &&
      !_vm.statistic.isSampleSizeIsTooLow &&
      !_vm.statistic.isRelativeStandardErrorTooHigh &&
      !_vm.statistic.isRelativeStandardErrorTooHigh &&
      !_vm.statistic.value.isMissing
    )?[_vm._v(" "+_vm._s(_vm.statistic.formattedSe)+" ")]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }